import React from 'react'
import { Box, IconButton, Tooltip } from '@mui/material'
import { HelpOutline } from '@mui/icons-material'

const ManualButton = () => (
  <Box>
    <Tooltip title="マニュアル">
      <span>
        <IconButton size="large" color="inherit"
                    className="open-help-button"
                    href="/manual" target="_blank" rel="noopener">
          <HelpOutline />
        </IconButton>
      </span>
    </Tooltip>
  </Box>
)

export default ManualButton
